import React, { useState, useEffect } from "react";
import Products from "../../components/Products/Products";
import "./ItemList.css"; // Import the CSS file for styling
import { Link } from "react-router-dom";
import ProductDiscription from "../../screens/ProductDiscription/ProductDiscription";

function ItemList({ data }) {
  const [filteredList, setFilteredList] = useState(data);
  const [selectedAlphabet, setSelectedAlphabet] = useState(null);



  const filterByAlphabet = (alphabet) => {
    const filteredItems = data.filter((item) => item.name.startsWith(alphabet));
    setFilteredList(filteredItems);
    setSelectedAlphabet(alphabet);
  };


  return (
    <div className="item-list-container">
      <h2>Medicines starting with - {selectedAlphabet}</h2>
      <div className="alphabet-buttons">
        {Array.from(Array(26), (_, i) => String.fromCharCode(65 + i)).map(
          (alphabet) => (
            <a
              key={alphabet}
              onClick={() => filterByAlphabet(alphabet)}
              className={`alphabet-button ${selectedAlphabet === alphabet ? "active" : ""
                }`}
            >
              {alphabet}
            </a>
          )
        )}
        <a
          onClick={() => filterByAlphabet("")} // Pass an empty string to reset the filter
          className={`alphabet-button reset-button ${selectedAlphabet === "" ? "active" : ""}`}
        >
          Reset
        </a>
      </div>
      <ul className="products-list">
        {filteredList.map((item, index) => (
          <li key={index}>
            {item &&
              item.imageSrc &&
              item.name &&
              item.description &&
              item.packSize &&
              item.price && (
                <Link to={`/product-discription/${item?.name}`} state={item}>
                  {console.log("item?.name:: ", item)}

                  <Products
                    imageSrc={item.imageSrc}
                    name={item.name}
                    description={item.description}
                    packSize={item.packSize}
                    price={item.price}
                  />
                </Link>
              )}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default ItemList;
